import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthSession } from '../../contexts/AuthSessionContext';
import { useBranding } from '../../branding/BrandingContext';
import { ensureActiveSession, logoutUser } from '../../services/session';
import ProductCheckoutModal from './ProductCheckoutModal';
import './CheckoutResult.css';

const ATENDABOT_PRODUCT_KEYS = ['atendabot'];
const ATENDABOT_PRODUCT_DESCRIPTION_OVERRIDES = {
  atendabot: 'Atendimento automatizado com IA no WhatsApp.',
};

const BillingRequired = () => {
  const navigate = useNavigate();
  const branding = useBranding();
  const { session, isHydrating, hasBillingAccess } = useAuthSession();
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const isAtendabotBrand = branding?.key === 'atendabot';
  const authenticatedPath = isAtendabotBrand
    ? branding?.authenticatedPath || '/atendabot'
    : '/products';

  useEffect(() => {
    void ensureActiveSession({ force: true }).catch(() => null);
  }, []);

  useEffect(() => {
    if (!session || isHydrating || !hasBillingAccess) return;
    navigate(authenticatedPath, { replace: true });
  }, [authenticatedPath, hasBillingAccess, isHydrating, navigate, session]);

  const handleLogout = async () => {
    await logoutUser();
    navigate('/login');
  };

  return (
    <>
      <div className="checkout-result">
        <div className="checkout-card">
          <span className="checkout-badge is-failure">Acesso pausado</span>
          <h1>
            {isAtendabotBrand
              ? 'Continue usando o AtendaBot'
              : 'Obrigado por explorar o Foodstation'}
          </h1>
          {isAtendabotBrand ? (
            <p>
              Ative sua assinatura para retomar o atendimento automatizado da sua conta.
            </p>
          ) : (
            <p>
              Para continuar usando, ative os produtos que fazem sentido para a sua operação.
              Você escolhe o que precisa e pode adicionar mais a qualquer momento.
            </p>
          )}
          <div className="checkout-actions">
            <button className="primary" type="button" onClick={() => setCheckoutOpen(true)}>
              {isAtendabotBrand ? 'Ativar AtendaBot' : 'Ativar produtos'}
            </button>
            <button className="secondary" type="button" onClick={handleLogout}>
              Sair
            </button>
          </div>
        </div>
      </div>
      <ProductCheckoutModal
        open={checkoutOpen}
        title={isAtendabotBrand ? 'Ativar AtendaBot' : 'Ativar produtos'}
        initialProductKey={isAtendabotBrand ? 'atendabot' : null}
        allowedProductKeys={isAtendabotBrand ? ATENDABOT_PRODUCT_KEYS : null}
        checkoutBrandName={isAtendabotBrand ? branding?.name || 'AtendaBot' : undefined}
        checkoutDescription={isAtendabotBrand
          ? 'Confirme a assinatura do AtendaBot para continuar com seus atendimentos.'
          : undefined}
        checkoutSummaryDescription={isAtendabotBrand
          ? 'Confira o valor mensal da sua assinatura antes de prosseguir.'
          : undefined}
        productDescriptionOverrides={isAtendabotBrand
          ? ATENDABOT_PRODUCT_DESCRIPTION_OVERRIDES
          : undefined}
        onActivated={() => navigate(authenticatedPath, { replace: true })}
        onClose={() => setCheckoutOpen(false)}
      />
    </>
  );
};

export default BillingRequired;
